export const COLLECTION_TAB_STORAGE_KEY = "vocabularium_collection_tab";

export const COLLECTION_TABS = {
  GEMS: "gems",
  POTIONS: "potions",
  KEYS: "keys",
};

const VALID_COLLECTION_TABS = new Set(Object.values(COLLECTION_TABS));

export function readCollectionTab() {
  try {
    const raw = localStorage.getItem(COLLECTION_TAB_STORAGE_KEY);
    if (VALID_COLLECTION_TABS.has(raw)) return raw;
  } catch {
    // ignore quota / privacy mode errors
  }
  return COLLECTION_TABS.GEMS;
}

export function writeCollectionTab(tab) {
  if (!VALID_COLLECTION_TABS.has(tab)) return;
  try {
    localStorage.setItem(COLLECTION_TAB_STORAGE_KEY, tab);
  } catch {
    // ignore quota / privacy mode errors
  }
}
